import React, { useState } from "react";
import { Avatar as MUIAvatar, AvatarProps, SxProps } from "@mui/material";
import { useTheme } from "contexts";
import { Helpers } from "utils";
import { Checks } from "helpers";

type Props = Omit<AvatarProps, "sx"> & {
  src?: string;
  size?: "small" | "medium" | "large" | "x-large";
  children?: React.ReactNode;
  foreground?: string; // Optional foreground color for custom color
  sx?: SxProps; // Allow additional styling overrides
};

export const Avatar = React.forwardRef<HTMLDivElement, Props>(
  ({ children, foreground, size = "medium", src, sx, ...props }, ref) => {
    const { theme } = useTheme();

    const [isTransparent, setIsTransparent] = useState<boolean>(true);

    const avatarSize =
      size === "small"
        ? 24
        : size === "medium"
          ? 32
          : size === "large"
            ? 48
            : 128;

    // Define the custom styles
    const avatarStyles: SxProps = {
      width: avatarSize,
      height: avatarSize,
      fontSize:
        size === "small" || size === "medium" ? theme.font.sm : theme.font.xxl,
      color: theme.color.primary.textAccent,
      backgroundColor: isTransparent
        ? "transparent"
        : theme.color.primary.accent,
      ...sx, // Allow overriding styles with sx prop
    };

    return (
      <MUIAvatar
        {...props}
        ref={ref}
        sx={avatarStyles}
        src={Checks.isBSON(src) ? Helpers.getUserAvatar(src) : src}
        onError={() => setIsTransparent(false)}
      >
        {children}
      </MUIAvatar>
    );
  }
);
